import React from 'react';

import PortalLogo from './PortalLogo';
import { font, palette } from '../styles';
import { usePortalCompact } from '../usePortalCompact';

import type { PropsWithChildren } from 'react';

interface Props {
  title?: string;
  headerSlot?: React.ReactNode;
}

const Layout: React.FC<PropsWithChildren<Props>> = ({ children, title, headerSlot }) => {
  const compact = usePortalCompact();

  return (
    <div
      style={{ background: palette.bg, minHeight: '100vh', fontFamily: font, color: palette.black }}
    >
      <div
        style={{
          padding: compact ? '24px 16px 16px' : '40px 16px 24px',
          display: 'flex',
          justifyContent: 'center'
        }}
      >
        <PortalLogo />
      </div>
      {title ? (
        <div style={{ display: 'flex', justifyContent: 'center', padding: '0 16px' }}>
          <h1
            style={{
              fontSize: compact ? 28 : 36,
              fontWeight: 700,
              color: palette.headingNeutral,
              margin: compact ? '16px 0 20px' : '40px 0 24px',
              letterSpacing: '-0.02em',
              textAlign: 'center',
              overflowWrap: 'anywhere'
            }}
          >
            {title}
          </h1>
        </div>
      ) : null}
      {headerSlot}
      <div
        style={{
          maxWidth: 1016,
          margin: '0 auto',
          padding: compact ? '0 16px 80px' : '0 24px 80px'
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default Layout;
